import React from "react";

import { Button, Grid } from "@mui/material";
import { BIOTRONIK } from "static/manufacturers";

import SubmitButton from "components/Button/SubmitButton";
import FormSelectField from "components/FormFields/FormSelect";
import FormTextField from "components/FormFields/FormTextField";
import FormPasswordField from "components/FormFields/FormPasswordField";

import useManufacturerAccountForm from "./useManufacturerAccountForm";
import { Formik } from "formik";
import { manufacturerAccountValidationSchema } from "schemas/manufacturerAccountValidationSchema";

const ManufacturerAccountForm = (props) => {
  const {
    accountList,
    isProcessing,
    manufacturersList,
    manufacturerAccountFormValues,

    handleFormSubmit,
  } = useManufacturerAccountForm(props);

  return (
    <Formik
      enableReinitialize
      initialValues={{ ...manufacturerAccountFormValues }}
      validationSchema={manufacturerAccountValidationSchema(props.isUpdate)}
      onSubmit={(values) => handleFormSubmit(values)}
    >
      {({ handleSubmit, touched, errors, values, handleChange }) => (
        <>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <FormSelectField
                margin="none"
                label="Manufacturer Name"
                required={true}
                disabled={props.isUpdate}
                value={values.manufacturer}
                errorMessage={errors.manufacturer}
                options={manufacturersList}
                hasError={touched.manufacturer && Boolean(errors.manufacturer)}
                onChange={handleChange("manufacturer")}
              />
            </Grid>
            <Grid item xs={6}>
              <FormSelectField
                label="Account"
                margin="none"
                required={true}
                disabled={props.isUpdate}
                value={values.account}
                options={accountList}
                errorMessage={errors.account}
                hasError={touched.account && Boolean(errors.account)}
                onChange={handleChange("account")}
              />
            </Grid>
            <Grid item xs={6}>
              <FormTextField
                fullWidth
                margin="none"
                label="User Group"
                inputProps={{ maxLength: 50 }}
                value={values.usergroup}
                required={values.manufacturer === BIOTRONIK}
                hasError={
                  values.manufacturer === BIOTRONIK &&
                  touched.usergroup &&
                  Boolean(errors.usergroup)
                }
                errorMessage={errors.usergroup}
                onChange={handleChange("usergroup")}
                disabled={props.isUpdate && values.manufacturer !== BIOTRONIK}
              />
            </Grid>
            <Grid item xs={6}>
              <FormTextField
                fullWidth
                margin="none"
                value={values.username}
                label="Username"
                required={true}
                inputProps={{ maxLength: 50 }}
                errorMessage={errors.username}
                hasError={touched.username && Boolean(errors.username)}
                onChange={handleChange("username")}
              />
            </Grid>

            {!props.isUpdate && (
              <>
                <Grid item xs={6}>
                  <FormPasswordField
                    fullWidth
                    required={true}
                    label="Password"
                    value={values.password}
                    errorMessage={errors.password}
                    hasError={touched.password && Boolean(errors.password)}
                    onChange={handleChange("password")}
                  />
                </Grid>

                <Grid item xs={6}>
                  <FormPasswordField
                    fullWidth
                    required={true}
                    label="Confirm Password"
                    value={values.confirmPassword}
                    errorMessage={errors.confirmPassword}
                    hasError={
                      touched.confirmPassword && Boolean(errors.confirmPassword)
                    }
                    onChange={handleChange("confirmPassword")}
                  />
                </Grid>
              </>
            )}
          </Grid>

          <div
            className="d-flex flex-end"
            style={{ gap: "10px", marginTop: 15 }}
          >
            <Button
              variant="outlined"
              color="secondary"
              onClick={props.handleClose}
              disabled={isProcessing}
            >
              Cancel
            </Button>

            <SubmitButton
              variant="contained"
              color="secondary"
              handleClick={handleSubmit}
              isLoading={isProcessing}
            />
          </div>
        </>
      )}
    </Formik>
  );
};

export default ManufacturerAccountForm;
